import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useStockItems } from '../_load/StockItemsLoader'
import { useRowsActions } from './_actions/rowsActions'

const MultiRowsActions = () => {
  const { stocks } = useStockItems()

  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedStocks = getSelectedData(stocks)
  const [menuOptions] = useRowsActions(head(selectedStocks), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
